import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于17黑料网的常见疑问与解答</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-xl border border-secondary-200/40 overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-200 text-sm"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}